import React from 'react';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../../api/apiClient';
import { usePreloaderStore, useConfirmationModalStore } from '../../../../../../stores';

// Обрыв цепочки с подтверждением — используется в карточке flagged-звена и в списке цепочек.
export default function useResetChain(onChanged) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const { open: openConfirm } = useConfirmationModalStore();

    return (chainId) => openConfirm(
        <div className="confirm-msg">
            <b>Оборвать цепочку?</b>
            <p>Текущее звено станет просроченным, держатель получит уведомление, а челлендж снова станет доступен для активации.</p>
        </div>,
        async () => {
            show();
            try {
                await apiClient.post(`/api/neighbor/admin/challenges/chains/${chainId}/reset`);
                enqueueSnackbar('Цепочка оборвана', { variant: 'success' });
                onChanged();
            } catch (e) {
                const msg = e.response?.status === 409
                    ? 'Цепочка уже закрыта'
                    : (e.response?.data?.message || 'Ошибка при обрыве цепочки');
                enqueueSnackbar(msg, { variant: e.response?.status === 409 ? 'warning' : 'error' });
                if (e.response?.status === 409) onChanged();
            } finally { hide(); }
        },
        { confirmText: 'Оборвать' }
    );
}
